export default __webpack_public_path__ + "static/media/kanuri.fd4d8388.svg";